export const SET_SHOW_SIDEBAR = '@navigation/SET_SHOW_SIDEBAR'